import { render, staticRenderFns } from "./ChatsFilters.vue?vue&type=template&id=406e35e4&"
import script from "./ChatsFilters.vue?vue&type=script&lang=ts&"
export * from "./ChatsFilters.vue?vue&type=script&lang=ts&"
import style0 from "./ChatsFilters.vue?vue&type=style&index=0&id=406e35e4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports